import React, { createContext, useContext, useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { loginData } from "model/LoginModel";
import { triggerStatusMetadataLoad } from "libs/context/statusMetadataBridge";
import { triggerPermissionLoad } from "libs/context/permissionBridge";
import { triggerUserSettingsSync } from "libs/context/userSettingBridge";
import { normalizeAuthSession } from "helpers/authSession";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [userData, setUserData] = useState();
  const navigate = useNavigate();

  const completeLoginSession = async (userDatas) => {
    const session = normalizeAuthSession(userDatas);
    if (!session?.accessToken) {
      toast.error("Sign-in could not be completed. Please try again.");
      return;
    }

    setUserData(session);
    localStorage.setItem("authUser", JSON.stringify(session.accessToken));
    localStorage.setItem("userData", JSON.stringify(session));

    try {
      triggerStatusMetadataLoad({ force: true });
      await triggerUserSettingsSync();
    } catch {
      // Do not block dashboard entry if settings sync fails right after SSO.
    }

    triggerPermissionLoad({ force: true });
    navigate("/dashboard", { replace: true });
  };

  const loginUser = async (formData) => {
    setLoading(true);
    try {
      const response = await loginData(formData);
      if (response?.success) {
        setLoading(false);
        await completeLoginSession(response?.data);
      } else {
        setLoading(false);
        toast?.error(response?.Message);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err.Message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchAll = async () => {
      await Promise.all([]);
    };
    fetchAll();
  }, []);

  return (
    <UserContext.Provider value={{ loginUser, completeLoginSession, loading, error }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => useContext(UserContext);
